import { Component, Input } from '@angular/core';
import { coButton, ConfigProvider } from '../../providers/config/config';
import { AppBlock } from '../../providers/config/config';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';

/**
 * Generated class for the CoBlockComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-block',
  templateUrl: 'co-block.html',
})
export class CoBlockComponent {
  blockType: string;
  button: coButton;
  clientKeyword: string;
  @Input() blockInfo: AppBlock;

  constructor(private config: ConfigProvider, private clientDetails: ClientDetailsProvider, private state : AppState) {
    // this.el.nativeElement.
  }
  getButtonParamsForBlock(block: AppBlock):coButton{
      return {
        text: block.title,
        color: "primary",
        icon: block.icon,
        full: true,
        linkURL: block.url,
        block: block,
        square: block.square|| false
      }
  }
  ngOnInit(){
    // console.log(this.blockInfo);
    this.config.load(this.state.appId).then(cfg => {
      this.clientDetails.load().then((data) => {
        this.clientKeyword = data.keyword;
      });
    });
  }

  showFilters(event){
    console.log(event);
  }
}



// WEBPACK FOOTER //
// ./src/components/co-block/co-block.ts